var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_10982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H8C3.58172 0 0 3.58172 0 8V48C0 52.4183 3.58172 56 8 56H48C52.4183 56 56 52.4183 56 48V8C56 3.58172 52.4183 0 48 0Z",
    fill: "url(#paint0_linear_1_10982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8308 16.334H16.1641C15.6118 16.334 15.1641 16.7817 15.1641 17.334V29.334C15.1641 29.8863 15.6118 30.334 16.1641 30.334H25.8308C26.383 30.334 26.8308 29.8863 26.8308 29.334V17.334C26.8308 16.7817 26.383 16.334 25.8308 16.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2448 26.834H29.5781C29.0258 26.834 28.5781 27.2817 28.5781 27.834V39.834C28.5781 40.3863 29.0258 40.834 29.5781 40.834H39.2448C39.7971 40.834 40.2448 40.3863 40.2448 39.834V27.834C40.2448 27.2817 39.7971 26.834 39.2448 26.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8308 32.084H16.1641C15.6118 32.084 15.1641 32.5317 15.1641 33.084V39.834C15.1641 40.3863 15.6118 40.834 16.1641 40.834H25.8308C26.383 40.834 26.8308 40.3863 26.8308 39.834V33.084C26.8308 32.5317 26.383 32.084 25.8308 32.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2448 16.334H29.5781C29.0258 16.334 28.5781 16.7817 28.5781 17.334V24.084C28.5781 24.6363 29.0258 25.084 29.5781 25.084H39.2448C39.7971 25.084 40.2448 24.6363 40.2448 24.084V17.334C40.2448 16.7817 39.7971 16.334 39.2448 16.334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_10982",
    x1: 12.6808,
    y1: 43.3231,
    x2: 45.7139,
    y2: 10.2899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F42334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FC6058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7866"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_10982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/blocks.cb07b5fa592f7f655986754eef27129c.svg";
export { ForwardRef as ReactComponent };